import { defineRecipe } from '@chakra-ui/react';
import { badgeVariants } from './badge';

const codeRecipe = defineRecipe({
  base: {
    colorPalette: 'gray',
    fontFamily: 'mono',
    fontSize: 'sm',
    px: '0.2em',
    borderRadius: 'sm',
  },
  variants: {
    variant: badgeVariants,
  },
  defaultVariants: {
    variant: 'subtle',
  },
});

export default codeRecipe;
